import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const SUPPORTS = [
    {
        src: "https://customer-assets.emergentagent.com/job_timber-workspace/artifacts/afzqdwck_infoblokk.jpg",
        alt: "Európai Unió Európai Regionális Fejlesztési Alap — Befektetés a jövőbe — Széchenyi 2020 támogatási arculat",
        href: "https://www.palyazat.gov.hu/",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_timber-workspace/artifacts/i96u1amg_kedvezmenyezetti-infoblokk-keretes.jpg",
        alt: "Széchenyi Terv Plusz — Magyarország Kormánya — Az Európai Unió társfinanszírozásával",
        href: "https://www.palyazat.gov.hu/",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_timber-workspace/artifacts/mvdezpuq_Forgoeszkozhitel_tamogatas.png",
        alt: "Forgóeszköz hitel támogatás 20 millió forint — BAU-Paks Szolgáltató Kft. — Gazdaságfejlesztési és Innovációs Operatív Program Plusz",
        href: "https://www.palyazat.gov.hu/",
    },
];

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#2C2724] text-[#F9F6F0] mt-24"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
                <div className="md:col-span-2">
                    <h3 className="font-serif text-5xl md:text-6xl tracking-tight leading-none">
                        BAU-Paks Kft
                        <span className="text-[#C98A4B]">.</span>
                    </h3>
                    <p className="mt-5 text-sm text-[#F9F6F0]/70 max-w-md leading-relaxed">
                        Egyedi bútor készítése és bútorgyártás Pakson —
                        konyhabútor, irodabútor és beépített bútor egyedi
                        igények szerint. Asztalos és épületasztalos-ipari
                        munkák 1996 óta.
                    </p>
                </div>

                <div>
                    <p className="overline text-[#C98A4B] mb-5">Menü</p>
                    <ul className="space-y-3 text-sm">
                        <li>
                            <Link
                                to="/szolgaltatasok"
                                data-testid="footer-services-link"
                                className="text-[#F9F6F0]/80 hover:text-[#F9F6F0] transition-colors"
                            >
                                Szolgáltatások
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/termekek"
                                data-testid="footer-products-link"
                                className="text-[#F9F6F0]/80 hover:text-[#F9F6F0] transition-colors"
                            >
                                Termékek
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/ajanlatkeres"
                                data-testid="footer-request-link"
                                className="text-[#F9F6F0]/80 hover:text-[#F9F6F0] transition-colors"
                            >
                                Ajánlatkérés
                            </Link>
                        </li>
                    </ul>
                </div>

                <div>
                    <p className="overline text-[#C98A4B] mb-5">Kapcsolat</p>
                    <ul className="space-y-3 text-sm text-[#F9F6F0]/80">
                        <li className="flex items-start gap-3">
                            <MapPin
                                size={16}
                                className="mt-0.5 text-[#D4A373] flex-shrink-0"
                            />
                            <a
                                href="https://www.google.com/maps/search/?api=1&query=7030+Paks+Tolnai+%C3%BAt+26"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-address-link"
                                className="hover:text-[#F9F6F0] underline decoration-[#D4A373]/40 underline-offset-4 hover:decoration-[#D4A373]"
                            >
                                7030 Paks, Tolnai út 26.
                            </a>
                        </li>
                        <li className="flex items-start gap-3">
                            <Phone
                                size={16}
                                className="mt-0.5 text-[#D4A373] flex-shrink-0"
                            />
                            <a
                                href="tel:+36202100472"
                                data-testid="footer-phone-link"
                                className="hover:text-[#F9F6F0]"
                            >
                                +36 20 210-0472
                            </a>
                        </li>
                        <li className="flex items-start gap-3">
                            <Mail
                                size={16}
                                className="mt-0.5 text-[#D4A373] flex-shrink-0"
                            />
                            <a
                                href="mailto:baupakskft@gmail.com"
                                data-testid="footer-email-link"
                                className="hover:text-[#F9F6F0]"
                            >
                                baupakskft@gmail.com
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            {/* Pályázati arculat / EU támogatás logók */}
            <div className="border-t border-[#F9F6F0]/10 bg-[#F9F6F0]">
                <div className="max-w-7xl mx-auto px-6 lg:px-12 py-10">
                    <p className="text-xs uppercase tracking-[0.24em] text-[#5C534D] text-center mb-6">
                        Pályázati támogatások
                    </p>
                    <div
                        data-testid="footer-supports"
                        className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center"
                    >
                        {SUPPORTS.map((s, i) => (
                            <a
                                key={i}
                                href={s.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={`support-logo-${i}`}
                                className="block bg-white p-3 hover:opacity-85 transition-opacity"
                            >
                                <img
                                    src={s.src}
                                    alt={s.alt}
                                    className="w-full h-auto object-contain max-h-32"
                                    loading="lazy"
                                />
                            </a>
                        ))}
                    </div>
                </div>
            </div>

            <div className="border-t border-[#F9F6F0]/10">
                <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[#F9F6F0]/50">
                    <p>
                        © {new Date().getFullYear()} BAU-Paks Kft. — Minden jog
                        fenntartva.
                    </p>
                    <p className="font-serif italic text-[#D4A373]/80">
                        Egyediség · Minőség · Tartósság
                    </p>
                </div>
            </div>
        </footer>
    );
}
